// extracted by mini-css-extract-plugin
export var cartContainer = "_m2-4";
export var gray = "_m2-1";
export var itemContainer = "_m2-2";
export var itemDetails = "_m2-3";
export var strong = "_m2-0";